import { uniqueId } from 'cadenza/utils/unique-id';
import { ajax, encodePathVariable } from 'cadenza/api-client/api';
import { cadenzaUrl, type CadenzaUrl } from 'cadenza/utils/cadenza-url/cadenza-url';

/** @see net/disy/cadenza/media/web/dto/MediaMetadataDto.java */
interface MediaMetadataDto {
  name: string;
  description: string;
  representations: RepresentationDto[];
}

/** @see net/disy/cadenza/media/web/dto/RepresentationDto.java */
interface RepresentationDto {
  url: string;
  type: RepresentationType;
  mediaType: string;
}

export interface MediaMetadata {
  id: string;
  name: string;
  description: string;
  representations: Representation[];
}

interface Representation {
  url: CadenzaUrl;
  type: RepresentationType;
  mediaType: string;
}

type RepresentationType = 'THUMBNAIL' | 'PREVIEW' | 'DOCUMENT';

/* @see net/disy/cadenza/media/web/rest/MediaEndpointController.java */
export function getMediaMetaData (dataProviderName: string, tableCellValue: string): Promise<MediaMetadata[]> {
  const params = new URLSearchParams({ filterByValue: tableCellValue });
  return ajax<MediaMetadataDto[]>(`/mediacollections/${encodePathVariable(dataProviderName)}/media?${params}`)
    .then((mediaMetadata = []) => extendMediaMetadata(mediaMetadata));
}

function extendMediaMetadata (metadata: MediaMetadataDto[]): MediaMetadata[] {
  for (const mediaItem of metadata) {
    for (const representation of mediaItem.representations) {
      representation.url = cadenzaUrl(representation.url);
    }
  }

  return metadata.map(mediaItem => ({
    id: uniqueId(),
    ...mediaItem
  }));
}
